"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Mattermost;
    }
});
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _requestfilteringagent = require("request-filtering-agent");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Mattermost = class Mattermost {
    init() {
        return Promise.resolve(undefined);
    }
    async sendMessage(text, payload) {
        for (const { webhook_url } of (payload == null ? void 0 : payload.channels) || []){
            try {
                return await _axios.default.post(webhook_url, {
                    text,
                    httpAgent: (0, _requestfilteringagent.useAgent)(webhook_url),
                    httpsAgent: (0, _requestfilteringagent.useAgent)(webhook_url)
                });
            } catch (e) {
                console.log(e);
                throw e;
            }
        }
    }
};
